export default "__VITE_ASSET__DW7W6Ntl__"